import { DriverWorkShiftEdit } from "@/models/driverWorkShiftsAndCycle";
import { DriverWorkShift } from "@/models/operationPlans";
import { AxiosResponse } from "axios";
import { httpClient } from "./API";

export const getDriverWorkShiftsAPI = async (
  officeId: number
): Promise<AxiosResponse<DriverWorkShift[]>> => {
  return httpClient.get("/core/internal/calgary/driverWorkShifts/", {
    params: {
      officeId,
    },
  });
};

export const getDriverWorkShiftAPI = async (
  driverWorkShiftId: number
): Promise<AxiosResponse<DriverWorkShift>> => {
  return httpClient.get(
    `/core/internal/calgary/driverWorkShifts/${driverWorkShiftId}`
  );
};

export const createDriverWorkShiftAPI = async (
  request: DriverWorkShiftEdit
): Promise<AxiosResponse<DriverWorkShift>> => {
  return httpClient.post(`/core/internal/calgary/driverWorkShifts/`, request);
};

export const updateDriverWorkShiftAPI = async (
  request: DriverWorkShiftEdit
): Promise<AxiosResponse<DriverWorkShift>> => {
  return httpClient.put(
    `/core/internal/calgary/driverWorkShifts/${request.id}`,
    request
  );
};

export const checkEffectiveShiftAPI = async (
  shiftId: number
): Promise<AxiosResponse<boolean>> => {
  return httpClient.get(
    `/core/internal/calgary/driverWorkShifts/${shiftId}/check/`
  );
};
